import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { defaultTransactionData, getTransactionById, editTransactionById } from '@/api/transactions';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import router from '@/router';
import { Action } from 'vuex-module-decorators';
import { searchDealers } from '@/api/dealers';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.formData = Object.assign({}, defaultTransactionData);
    this.loading = false;
    this.transactionId = null;
    this.transaction = null;
    this.payableAmount = 0;
    this.dealerListLoading = false;
    this.dealerList = [];
    this.rules = {
      transactionReference: {
        required: true,
        trigger: 'blur',
        message: 'Please enter transaction reference'
      },
      amount: {
        required: true,
        trigger: 'blur',
        message: 'Please enter transaction amount'
      },
      transactionDate: {
        required: true,
        trigger: 'blur',
        message: 'Please enter transaction date'
      },
      paymentMethod: {
        required: true,
        trigger: 'blur',
        message: 'Please select mode of payment'
      }
    };
    this.statusOptions = [{
      label: 'Success',
      key: 'success'
    }, {
      label: 'Failure',
      key: 'failure'
    }];
  }
  get lang() {
    return AppModule.language;
  }
  activated() {
    this.transactionId = +this.$route.params.id;
    this.getTransactionInfo(this.transactionId);
    this.formData = Object.assign({}, defaultTransactionData);
    this.tempTagView = Object.assign({}, this.$route);
  }
  async getTransactionInfo(id) {
    try {
      this.transaction = await getTransactionById(id);
      if (this.transaction) {
        this.formData = this.transaction;
      }
      // Just for test
      const title = 'Add Transaction';
      // // Set tagsview title
      this.setTagsViewTitle(title);
      // // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  isDateAllowed(time) {
    return time.getTime() > Date.now();
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.transactionId}`;
  }
  async getDealerList(query = null) {
    try {
      const isNumeric = /^[0-9]+$/.test(query);
      // search only if length is greater than 1 if query is id else 2
      if (!query || (isNumeric ? query.length < 1 : query.length < 2)) {
        this.dealerList = [];
        return;
      }
      this.dealerList = await searchDealers({
        keyword: query,
        searchBy: isNumeric ? 'dealerId' : 'name'
      });
    } catch (error) {} // eslint-disable-line  no-empty
  }
  submitForm() {
    this.saveForm();
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  async saveForm() {
    try {
      this.loading = true;
      await editTransactionById(this.transactionId, this.formData);
      this.loading = false;
      this.$notify({
        title: 'Success',
        message: 'Transaction saved successfully',
        type: 'success',
        duration: 2000
      });
      router.push('/transaction/list');
    } catch (err) {
      this.loading = false;
    }
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'TransactionDetail',
  components: {}
})], default_1);
export default default_1;